import React, {useEffect} from 'react';

/* Bootstrap */
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

/* Logo */
import logo from '../img/petfriends.svg';

/* Smooth Scroll */
import { Link } from "react-scroll";

const Navigation = () => {
  useEffect(() => {
		let scrollpos = window.scrollY;
		const header = document.querySelector('#navigation');
		const header_height = header.offsetHeight;

		const add_class_on_scroll = () => header.classList.add('shadow');
		const remove_class_on_scroll = () => header.classList.remove('shadow');
		window.addEventListener('scroll', () => {
				scrollpos = window.scrollY;
        scrollpos >= header_height ? add_class_on_scroll() : remove_class_on_scroll();
		});
  }, [])
  
  return(
    <>
      <Navbar collapseOnSelect expand="lg" variant="light" fixed="top" id="navigation" className="idle-nav-pad">
      <Navbar.Brand href="" className="ml-sm-5">
        <Link
            to="top"
            spy={true}
            smooth={true}
            offset={0}
            duration= {800}
        >
            <div className="logo-container">
              <img src={logo} alt="logo" id="main-logo" load="lazy" height={40}/>
            </div>
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
          <Nav>
          <Link
            to="top"
            spy={true}
            smooth={true}
            offset={0}
            duration= {800}
          >
            <span className="mr-sm-5 text-center">Home</span>
          </Link>
          <Link
            to="services"
            spy={true}
            smooth={true}
            offset={0}
            duration= {800}
          >
            <span className="mr-sm-5 text-center">Services</span>
          </Link>
          <Link
            to="about"
            spy={true}
            smooth={true}
            offset={0}
            duration= {800}
          >
            <span className="mr-sm-5 text-center">About</span>
          </Link>
          <Link
            to="contact"
            spy={true}
            smooth={true}
            offset={0}
            duration= {800}
          >
            <span className="mr-sm-5 text-center">Contact</span>
          </Link>
          </Nav>
      </Navbar.Collapse>
      </Navbar>
    </>
  );
}

export default Navigation;
